import { render } from "./PerioGardOne.vue?vue&type=template&id=586be7b4&scoped=true"
import script from "./PerioGardOne.vue?vue&type=script&lang=js"
export * from "./PerioGardOne.vue?vue&type=script&lang=js"

import "./PerioGardOne.vue?vue&type=style&index=0&id=586be7b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586be7b4"]])

export default __exports__